module.exports = __webpack_public_path__ + "static/img/news2.6e15b07.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/news2.jpg
// module id = 2yfh
// module chunks = 1